var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.show)?_c('div',{staticClass:"content"},[_c('div',{staticClass:"warn-tips"},[_c('span',{staticClass:"msg"},[_vm._v(_vm._s(_vm.msg))])]),_c('span',{staticClass:"times"},[_vm._v(_vm._s(_vm.times+' 秒后自动关闭'))]),_c('span',{staticClass:"close-btn",on:{"click":_vm.close}},[_vm._v("X")])]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }